import { http } from '~~core';

import {
  DigitalCertificateLocalStartPayload,
  digitalCertificateLocalStartDataSchema,
  DigitalCertificateLocalCompletePayload,
  digitalCertificateLocalCompleteDataSchema,
  digitalCertificateCloudDiscoverDataSchema,
  digitalCertificateCloudCompleteDataSchema,
} from '../schemas/digital-certificate';

export async function startDigitalCertificateLocal(signatureRequestKey: string, body: DigitalCertificateLocalStartPayload) {
  const { icpSignatures } = await http(`/notarial/widget/signatures/${signatureRequestKey}/icp/start`, {
    method: 'post',
    body,
  });

  return digitalCertificateLocalStartDataSchema.parse(icpSignatures);
}

export async function completeDigitalCertificateLocalSignature(signatureRequestKey: string, body: Error | DigitalCertificateLocalCompletePayload) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/icp/complete`, {
    method: 'post',
    body,
  });

  return digitalCertificateLocalCompleteDataSchema.parse(data);
}

export async function discoverDigitalCertificateCloud(signatureRequestKey: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/icp_cloud/discover`);

  return digitalCertificateCloudDiscoverDataSchema.parse(data).providers;
}

export async function completeDigitalCertificateCloud(signatureRequestKey: string) {
  const data = await http(`/notarial/widget/signatures/${signatureRequestKey}/icp_cloud/complete`, {
    method: 'post',
  });

  return digitalCertificateCloudCompleteDataSchema.parse(data);
}
